import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbCarouselModule],
  selector: 'app-onboarding-wallet-front',
  templateUrl: './onboarding-wallet-front.component.html',
})
export class OnboardingWalletFrontComponent {

}
